function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "ic-touch_svg__a"
}, React.createElement("path", {
  fill: "none",
  d: "M31 43.66h50v43.35H31z"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0-2h130v130H0z",
  fill: "none"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 65,
  cy: 63,
  r: 56
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  "data-name": "b",
  cx: 65,
  cy: 63,
  r: 56,
  fill: "#fff",
  stroke: "#12123b",
  strokeWidth: 2
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29 27h72v72H29z",
  fill: "none"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M85 86.51a3.41 3.41 0 01-2.47-1l-18-17.95a3.5 3.5 0 01-1-2.48 3.5 3.5 0 016-2.47l18 18a3.43 3.43 0 011 2.47 3.48 3.48 0 01-3.5 3.5",
  fill: "#fff"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M74.55 53.49a1 1 0 01-.5-1.76 5.85 5.85 0 10-8.1-8 1 1 0 11-1.64-1 7.76 7.76 0 0114.43 4 7.71 7.71 0 01-3.69 6.6.9.9 0 01-.5.16z",
  fill: "#ffd24d"
});

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#ic-touch_svg__a)",
  fill: "#d3b1a7"
}, React.createElement("path", {
  d: "M73.27 74.54l-3.78-.18-.18-3.77a2.8 2.8 0 114 4z"
}), React.createElement("path", {
  d: "M69.31 70.59l-3.77-.18-.18-3.77a2.79 2.79 0 014 4z"
}), React.createElement("path", {
  d: "M65.36 66.64l-3.77-.18-.18-3.78a2.8 2.8 0 114 4z"
}), React.createElement("path", {
  d: "M61.43 62.66L73 51.13a2.92 2.92 0 00.22-4 2.79 2.79 0 00-4-.1L50.24 66A11.26 11.26 0 0047 75.65l-9 9a2.61 2.61 0 001.85 4.46h12.33L56.33 85a11.26 11.26 0 009.7-3.21l7.2-7.2-11.8-11.89s-.01-.02 0-.04z"
}));

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M73 72.44l-3.77-.18-.23-3.77a2.79 2.79 0 014 4z",
  fill: "#fad4c6"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69 68.49l-3.78-.18-.18-3.77a2.8 2.8 0 014 3.95z",
  fill: "#fad4c6"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M65.07 64.54l-3.77-.19-.18-3.77a2.8 2.8 0 113.95 4z",
  fill: "#fad4c6"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M61.14 60.56L72.68 49a2.91 2.91 0 00.21-4 2.8 2.8 0 00-4-.09L50 63.85a11.21 11.21 0 00-3.2 9.7L36.08 84.23A1.63 1.63 0 0037.23 87H51a2.21 2.21 0 001.57-.65L56 82.87a11.22 11.22 0 009.7-3.2l7.2-7.2L61.14 60.6v-.04z",
  fill: "#fad4c6"
});

var SvgIcTouch = function SvgIcTouch(props) {
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 130 130"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

export default "data:image/svg+xml;base64,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";
export { SvgIcTouch as ReactComponent };